export default "__VITE_ASSET__e85cbdf2__"